import { VEHICLES_DELETE_STR } from "common/sf_strings";
import { MODE, REQUIRED_FEATURE_FLAGS, LEAD_TYPE_IDS } from "helpers/sf_constants";
import { optionsRevenueOrPayRoll } from "helpers/sf_lead_constants";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { isBenepathBrand } from "config";
import { addLeadBusinessEntity, deleteLeadBusinessEntity, updateLeadBusinessEntity } from "store/leads/lead_business_entity_actions";
import DeleteModal from "../DeleteModal";
import AddBusinessEntityModal from "../Modals/AddBusinessEntityModal";
import LeadEditDropdown from "./LeadEditDropdown";
import { getPrimaryTextClass } from "helpers/sf_utils";
import { addProspectBusinessEntity, deleteProspectBusinessEntity, updateProspectBusinessEntity } from "store/prospects/prospects_business_entity_actions";
import useFeatureFlags from 'hooks/useFeatureFlags';
import useSicCodeTargeting from "hooks/useSicCodeTargeting";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { useContext } from "react";

const LeadBusinessEntity = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [businessEntityModal, setBusinessEntityModal] = useState({ active: false });
    const [lead_data, setLeadData] = useState({})
    const { lead_id } = useParams();
    const [isFeatureFlagActive] = useFeatureFlags();
    const { isEnableSicEightTargeting, isFfEnableSicCodeTargeting } = useSicCodeTargeting(props);
    const [businessEntityDeleteModal, setBusinessEntityDeleteModal] = useState({ active: false, business_entity: {} })
    const dispatch = useDispatch();
    let businessEntityUpdater = updateLeadBusinessEntity
    let businessEntityAdder = addLeadBusinessEntity
    let businessEntityDeleter = deleteLeadBusinessEntity
    if (props?.is_prospect) {
        businessEntityUpdater = updateProspectBusinessEntity;
        businessEntityAdder = addProspectBusinessEntity
        businessEntityDeleter = deleteProspectBusinessEntity
    }
    //Create a useeffect and get lead data from redux store from lead_id from useParams

    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);

        }
    }, [props?.lead_data])

    const handleLaunchBusinessEntityModal = (value) => {
        setBusinessEntityModal({ active: value });
    };

    const onClickBusinessEntity = (mode, values) => {
        if (mode === MODE.EDIT) {
            dispatch(businessEntityUpdater({ lead_business_entity: values, lead_id }))
        } else {
            dispatch(businessEntityAdder({ ...values, lead_id: lead_id }))
        }
        handleLaunchBusinessEntityModal(false)
    }

    // For Delete Vehicle Modal
    const launchDeleteBusinessEntiyModal = (business_entity) => {
        setBusinessEntityDeleteModal({ action: true, business_entity: business_entity });
    };

    const onClickVehicleDeleteModal = (payload) => {
        dispatch(businessEntityDeleter({ id: payload?.business_entity?.id }));
        setBusinessEntityDeleteModal({ action: false, business_entity: {} });
    };

    const shouldShowIndustryDetails = () => {
        return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_SIC_CODE_TARGETING) &&
            lead_data?.lead_type_id === LEAD_TYPE_IDS.COMMERCIAL;
    };

    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={businessEntityDeleteModal}
                onDeleteClick={onClickVehicleDeleteModal}
                textMessage={VEHICLES_DELETE_STR}
                onCloseClick={() => setBusinessEntityDeleteModal({ action: false, business_entity: {} })}
                cancelButton
            />
            <AddBusinessEntityModal
                onClickBusinessEntity={onClickBusinessEntity}
                onCloseClick={() => setBusinessEntityModal(false)}
                show={businessEntityModal}
                title='Business Entity'
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_business_entities?.map((business_entity, idx) =>
                                (
                                    <tbody id='primary_vehicles'>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-end pt-1 my-2">
                                                    <i className={`me-2 bx fs-24 bxs-buildings ${getPrimaryTextClass()}`} />
                                                    <div className="me-2 fs-15 font-weight-semibold">
                                                        Business #{idx + 1}
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => setBusinessEntityModal({ active: true, mode: MODE.EDIT, values: business_entity })}>
                                                                Edit
                                                            </a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly &&
                                                    <Col className={`${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex ${getPrimaryTextClass()}`}
                                                                onClick={() => launchDeleteBusinessEntiyModal(business_entity)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Business Name
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Business Name'
                                                            field={business_entity?.business_name || '--'}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = business_entity?.id
                                                                data.business_name = value
                                                                dispatch(businessEntityUpdater({ lead_business_entity: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td colSpan={1}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Year in Business
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Year in Business'
                                                            field={business_entity?.yrs_in_business}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = business_entity?.id
                                                                data.yrs_in_business = value
                                                                dispatch(businessEntityUpdater({ lead_business_entity: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Business Description
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Business Description'
                                                            field={business_entity?.business_desc || '--'}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = business_entity?.id
                                                                data.business_desc = value
                                                                dispatch(businessEntityUpdater({ lead_business_entity: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td colSpan={1}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Number of Employees
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Number of Employees'
                                                            field={business_entity?.num_full_time_employees}
                                                            defaultValue={business_entity?.num_full_time_employees}
                                                            isProspect={props?.is_prospect}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = business_entity?.id
                                                                data.num_full_time_employees = value
                                                                dispatch(businessEntityUpdater({ lead_business_entity: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Annual Revenue
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsRevenueOrPayRoll}
                                                            title='Annual Revenue'
                                                            field={business_entity?.annual_revenue}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = business_entity?.id
                                                                data.annual_revenue = value
                                                                dispatch(businessEntityUpdater({ lead_business_entity: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            {shouldShowIndustryDetails() && (
                                                <>
                                                    {(isFfEnableSicCodeTargeting && isBenepathBrand) && (
                                                        <>
                                                            <td style={{ width: '33%' }}>
                                                                <div className="d-flex align-items-center">
                                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                                        SIC
                                                                    </Label>
                                                                    <div className="d-flex align-items-center">
                                                                        <span>{business_entity?.sic4 || '--'}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: '33%' }}>
                                                                <div className="d-flex align-items-center">
                                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                                        NAICS
                                                                    </Label>
                                                                    <div className="d-flex align-items-center">
                                                                        <span>{business_entity?.naics || '--'}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </tr>

                                        {shouldShowIndustryDetails() && isEnableSicEightTargeting && (
                                            <tr>
                                                <td colSpan={3}>
                                                    <div className="d-flex align-items-center">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            SIC8
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <span>{business_entity?.sic8 || '--'}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        {!isReadOnly &&
                            <div className="text-sfblue font-weight-semibold mt-4">
                                <a onClick={() => handleLaunchBusinessEntityModal(true)}>
                                    + Add Business Entity
                                </a>
                            </div>
                        }
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadBusinessEntity